<template>
  <v-container
    id="towerServices"
    fluid
    tag="section"
  >
    <v-card
      class="mx-4 px-4 py-4"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-btn
              @click="doGetAccessPoints"
            >
              Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-data-table
        :headers="headersAps"
        :items="accessPoints"
        :items-per-page="3000"
        item-key="Id"
        sort-by="Id"
        show-group-by
        class="elevation-1"
      >
        <template v-slot:item.LatestValues="{ item }">
          <v-row
            v-if="item._latestValues"
            class="d-flex"
          >
            <v-card
              class="mx-2 px-1 pt-1"
              v-for="(stat, idx) of item._latestValues"
              :key="idx"
            >
              <p>{{ stat.description }}</p>
              <p>{{ stat.value }}</p>
              <p>Sample: {{ formatEpoch(stat.timestamp, 'YYYY-MM-DD HH:mm') }}</p>
            </v-card>
          </v-row>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  // import { mapActions, mapGetters } from 'vuex'
  import moment from '../../../assets/js/moment.min'
  import PowAccessPointService from '../../../services/pow-ap.service'
  import basic from '../../../mixins/basic'

  export default {
    name: 'AccessPoints',

    mixins: [basic],
    data () {
      return {
        page: 1,
        filter: {},
        sortBy: 'created_at',
        optionsSoryBy: [
          'rowkey',
          'created_at',
        ],
        headersAps: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'Name',
          },
          {
            text: 'Type',
            align: 'start',
            sortable: false,
            groupable: false,
            value: 'Type',
          },
          {
            text: 'Tower',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'Tower',
          },
          {
            text: 'Values',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'LatestValues',
          },
        ],

        itemsPerPageArray: [50, 100, 250, 500, 1000],
        accessPoints: [],
      }
    },
    computed: {
      // ...mapGetters(['reportingWirelessServices', 'reportingTowers']),
    },
    async created () {
      console.log('page loaded')
      console.log(this.$route)
      // if (this.$route.params.account) {
      //   this.selectedAccount = this.$route.params.account
      // } else if (this.$route.params.key) {
      //   const payload = {
      //     key: this.$route.params.key,
      //     params: this.$route.query,
      //   }
      //   this.selectedAccount = await this.getAccount(payload)
      // }
      // if (!this.reportingTowers || this.reportingTowers.length === 0) {
      //   this.getTowers()
      // }
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      // ...mapActions(['getWirelessServices', 'getTowers']),
      async doGetAccessPoints () {
        const { data } = await PowAccessPointService.get()
        console.log(data)
        this.accessPoints = data
      },
      nextPage () {
        if (this.page + 1 <= this.numberOfPages) this.page += 1
      },
      formerPage () {
        if (this.page - 1 >= 1) this.page -= 1
      },
      updateItemsPerPage (number) {
        this.itemsPerPage = number
      },
      convertEpochMs (epoch) {
        console.log(epoch)
        return moment.unix(epoch / 1000).format('dddd, MMMM Do, YYYY h:mm:ss A')
      },
    },
  }
</script>
